import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Estilos para el documento PDF
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: "Helvetica",
  },
  title: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
    fontWeight: "bold", // Para resaltar el texto
    fontFamily: "Times-Bold",
    marginTop: 10,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    backgroundColor: "#052956", // Fondo azul oscuro
    color: "#FFFFFF", // Letra en blanco
    fontWeight: "bold",
    flex: 1,
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    flex: 1,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
});
const TableGroup = ({
  data = [],
  headers = [],
  headerDescriptions = [],
  questionTitle = "",
}) => (
  <>
    <Text style={styles.title}>{questionTitle}</Text>
    <View style={styles.table}>
      {/* Encabezados de la tabla */}
      <View style={styles.tableRow}>
        {Array.isArray(headerDescriptions)
          ? headerDescriptions.map((description, index) => (
              <View key={index} style={styles.tableColHeader}>
                <Text style={styles.tableCell}>{description ?? ""}</Text>
              </View>
            ))
          : null}
      </View>

      {/* Filas de la tabla */}
      {Array.isArray(data)
        ? data.map((row, rowIndex) => (
            <View key={rowIndex} style={styles.tableRow}>
              {Array.isArray(headers)
                ? headers.map((header, colIndex) => (
                    <View key={colIndex} style={styles.tableCol}>
                      {/* Verificar si el valor es un array */}
                      {Array.isArray(row?.[header]) ? (
                        row[header].length > 0 ? (
                          row[header].map((item, i) => (
                            <Text key={i} style={styles.tableCell}>
                              - {item}
                            </Text>
                          ))
                        ) : (
                          <Text style={styles.tableCell}>Sin datos</Text>
                        )
                      ) : (
                        <Text style={styles.tableCell}>
                          {row?.[header] ?? "Sin datos"}
                        </Text>
                      )}
                    </View>
                  ))
                : null}
            </View>
          ))
        : null}
    </View>
  </>
);

export default TableGroup;
